import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/annual-tax-documents`;

// Everyone payroll withheld tax from in this year, with what they were paid, what
// was withheld, and whether their annual certificate has been issued yet.
const getAnnualTaxDocuments = async (year) => {
    return await axios.get(`${API_URL}?year=${year}`);
};

// Issue the annual 50 ทวิ for one company employee. Idempotent on the server: a
// year already issued comes back with created: false and the same number, rather
// than minting a second document for the same person-year.
const issueAnnualCertificate = async (adminId, year) => {
    return await axios.post(`${API_URL}/issue`, { adminId, year });
};

// The endpoints are authenticated, so the PDF is fetched as a blob and opened
// from an object URL — a plain link would arrive without the session cookie.
const openPdf = async (path, params) => {
    const response = await axios.get(`${API_URL}${path}`, { params, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    window.open(url, '_blank');
    // Revoked late so the new tab has time to load the blob.
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

// One company employee's annual certificate.
const openAnnualCertificatePdf = (adminId, year) => openPdf('/certificate', { adminId, year });

// A freelancer's whole year: the summary sheet, then every certificate behind it.
const openAnnualBundlePdf = (adminId, year) => openPdf('/bundle', { adminId, year });

const AnnualTaxDocumentService = {
    getAnnualTaxDocuments,
    issueAnnualCertificate,
    openAnnualCertificatePdf,
    openAnnualBundlePdf,
};

export default AnnualTaxDocumentService;
